import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["children", "color"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { makeStyles, Button, GRAY, BLUE, WHITE } from '@applyboard/ui-components';
var useStyles = makeStyles({
  button: {
    borderRadius: function borderRadius(props) {
      return props.withRadius ? null : '0 !important';
    },
    left: 0,
    bottom: 0,
    width: '100%',
    height: '56px',
    backgroundColor: function backgroundColor(props) {
      return props.isBackButton ? "".concat(GRAY[21], " !important") : BLUE[10];
    },
    color: function color(props) {
      return props.isBackButton ? "".concat(GRAY[5], " !important") : WHITE;
    },
    borderTop: function borderTop(props) {
      return props.isBackButton ? "1px solid ".concat(GRAY[18], " !important") : '0px';
    }
  }
});
var FooterButton = function FooterButton(_ref) {
  var form = _ref.form,
    label = _ref.label,
    onClick = _ref.onClick,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$isBackButton = _ref.isBackButton,
    isBackButton = _ref$isBackButton === void 0 ? false : _ref$isBackButton,
    _ref$withRadius = _ref.withRadius,
    withRadius = _ref$withRadius === void 0 ? false : _ref$withRadius,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color;
  var classes = useStyles({
    isBackButton: isBackButton,
    withRadius: withRadius
  });
  return /*#__PURE__*/React.createElement(Button, {
    className: classes.button,
    form: form,
    onClick: onClick,
    type: type,
    color: color
  }, label);
};
export default FooterButton;
export var FooterButtonWithRadius = function FooterButtonWithRadius(_ref2) {
  var children = _ref2.children,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'primary' : _ref2$color,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(FooterButton, _extends({
    withRadius: true,
    label: children,
    color: color
  }, otherProps));
};